// Admin authentication state - stored in memory only
// Persists across admin page navigations but lost on refresh
import { ref, type Ref } from 'vue'

// Global state (outside function) - persists across component instances
const apiKey = ref<string>('')
const authenticated = ref<boolean>(false)

export interface AdminAuth {
  apiKey: Ref<string>
  authenticated: Ref<boolean>
  setApiKey: (key: string) => void
  clearApiKey: () => void
  promptApiKey: () => string | null
  ensureAuthenticated: () => string | null
}

export function useAdminAuth(): AdminAuth {
  const setApiKey = (key: string): void => {
    apiKey.value = key
    authenticated.value = !!key
  }

  const clearApiKey = (): void => {
    apiKey.value = ''
    authenticated.value = false
  }

  const promptApiKey = (): string | null => {
    const key = prompt('Enter Admin API Key:')
    if (key) {
      setApiKey(key)
      return key
    }
    return null
  }

  const ensureAuthenticated = (): string | null => {
    if (!authenticated.value) {
      return promptApiKey()
    }
    return apiKey.value
  }

  return {
    apiKey,
    authenticated,
    setApiKey,
    clearApiKey,
    promptApiKey,
    ensureAuthenticated,
  }
}
